import { createContext } from "react";

/**
 * Context for live region announcements
 *
 */
export const LiveRegionContext = createContext(null);
